/**
 * DialogHeader — Title + close button row
 *
 * Sits at the top of a Dialog. Renders the title on the left
 * and an X close button on the right, separated by a bottom border.
 */
import type { ReactNode } from 'react'
import { styled, XStack, Text as TamaguiText } from 'tamagui'

const DialogHeaderFrame = styled(XStack, {
  name: 'DialogHeader',
  ai: 'center',
  jc: 'space-between',
  px: '$md',
  py: '$sm',
  borderBottomWidth: 1,
  borderColor: '$borderColor',
})

const DialogTitle = styled(TamaguiText, {
  name: 'DialogTitle',
  fontFamily: '$body',
  fontSize: 18,
  fontWeight: '600',
  color: '$color',
  f: 1,
})

interface DialogHeaderProps {
  title: string
  /** Rendered on the right — typically an IconButton with X icon */
  right?: ReactNode
  /** Convenience: called when the close button is pressed. Renders a default X button if `right` is not provided. */
  onClose?: () => void
}

export function DialogHeader({ title, right, onClose }: DialogHeaderProps) {
  return (
    <DialogHeaderFrame>
      <DialogTitle>{title}</DialogTitle>
      {right}
    </DialogHeaderFrame>
  )
}
